module.exports = __webpack_public_path__ + "static/img/2-5.fa72004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-5.jpg
// module id = 4Ap2
// module chunks = 1